module.exports = __webpack_public_path__ + "img/rubik-regular-webfont.c5bb22fa.c5bb22fa.svg";